module.exports = __webpack_public_path__ + "static/media/PM114.0fd3e0e0.png";